import { Validate } from '@edgvr-front/util/validate';
import { WorkshopName, workshopName } from '@edgvr-front/workshops/domain';
import {
  DataId,
  DataStartedAt,
  DataWorkshopEntityId,
  DataWorkshopEntityRaw as DataWorkshopEntityRaw0,
} from '../interface';
import { dataId, dataStartedAt, dataWorkshopEntityId } from '../schema';
import { DataVO } from '../vo';

export class DataWorkshopEntity {
  private static validation = Validate.compile(
    DataWorkshopEntity.validationSchema(),
    DataVO
  );

  constructor(readonly value: DataWorkshopEntityRaw) {
    Validate.assert(DataWorkshopEntity.validation, value);
  }

  toJSON() {
    return {
      ...this.value,
      data: this.value.data.toJSON(),
    };
  }

  static factory(dataWorkshopEntityRaw: DataWorkshopEntityRaw0) {
    return new DataWorkshopEntity({
      ...dataWorkshopEntityRaw,
      data: DataVO.factory(dataWorkshopEntityRaw.data),
    });
  }

  private static validationSchema() {
    return {
      type: 'object',
      required: ['id', 'workshopName', 'dataId', 'data', 'startedAt'],
      properties: {
        id: dataWorkshopEntityId,
        workshopName,
        dataId,
        data: {
          instanceof: DataVO.name,
        },
        startedAt: dataStartedAt,
      },
      additionalProperties: false,
    };
  }
}

interface DataWorkshopEntityRaw {
  id: DataWorkshopEntityId;
  workshopName: WorkshopName;
  dataId: DataId;
  data: DataVO;
  startedAt: DataStartedAt;
}
